function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFertilizerProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .485)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 546",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(0 -.485)",
    style: {
      fill: "#26791c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2745",
    d: "M19.583 13.744a1.05 1.05 0 0 1-.743-.307 4.637 4.637 0 0 0-6.4 0 1.05 1.05 0 0 1-1.485-1.485 6.627 6.627 0 0 1 9.375 0 1.05 1.05 0 0 1-.743 1.792m2.958-2.958a1.055 1.055 0 0 1-.743-.307 8.723 8.723 0 0 0-12.322 0 1.05 1.05 0 0 1-1.489-1.486 10.828 10.828 0 0 1 15.293 0 1.05 1.05 0 0 1-.743 1.792M25.5 7.826a1.051 1.051 0 0 1-.743-.306 12.908 12.908 0 0 0-18.24 0 1.051 1.051 0 0 1-1.486-1.485 15.015 15.015 0 0 1 21.211 0 1.049 1.049 0 0 1-.742 1.791",
    transform: "translate(2.776 .824)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2798"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2799"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2746",
    d: "M20.87 5.506a9.872 9.872 0 0 1-4.637 11.736c-.265.144-.535.27-.806.387a5.929 5.929 0 0 1-.375 1.147 10.538 10.538 0 0 0 6.8-7.11 10.813 10.813 0 0 0-.016-6.246 8.539 8.539 0 0 0-.97.085",
    transform: "translate(6.619 13.223)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2747",
    d: "M8.809 18.274A9.822 9.822 0 0 1 1.054 7.165a5.806 5.806 0 0 1-.789-.908 10.8 10.8 0 0 0 1.017 7.492 10.682 10.682 0 0 0 7.134 5.391 8.735 8.735 0 0 0 .393-.866",
    transform: "translate(7.5 13.181)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2748",
    d: "M23.2 3.448a5.033 5.033 0 0 0-5.707-1.9 5.1 5.1 0 0 0-2.923 5.281c.044.323.193.5.443.531h.054a.482.482 0 0 0 .425-.26 8.348 8.348 0 0 1 3.271-2.194.485.485 0 0 0 .061-.025 8.27 8.27 0 0 1 3.882-.6.483.483 0 0 0 .526-.138.533.533 0 0 0-.032-.7",
    transform: "translate(6.649 13.435)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2749",
    d: "M8.111 5.576a.48.48 0 0 0-.46-.289A8.306 8.306 0 0 1 4.13 3.53a.426.426 0 0 0-.051-.042A8.389 8.389 0 0 1 1.619.4a.483.483 0 0 0-.382-.391C.985-.039.793.091.653.39a5.135 5.135 0 0 0 1.226 5.928 4.483 4.483 0 0 0 2.8.973 5.573 5.573 0 0 0 3.2-1.062.528.528 0 0 0 .234-.653",
    transform: "translate(7.488 13.499)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2750",
    d: "M11.131 12.4a.519.519 0 0 0-.68.121.492.492 0 0 0-.018.548 8.455 8.455 0 0 1 .25 3.951.513.513 0 0 0-.009.066 8.454 8.454 0 0 1-1.422 3.69.486.486 0 0 0 .375.854h.094a5.071 5.071 0 0 0 4.484-4.034 5.094 5.094 0 0 0-3.074-5.196",
    transform: "translate(6.968 12.871)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2751",
    d: "M11.513 9.795a2.252 2.252 0 1 0-1.065.27 2.253 2.253 0 0 0 1.065-.27",
    transform: "translate(7.855 13.874)",
    style: {
      fill: "none",
      stroke: "#f5f5f5",
      strokeWidth: ".5px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizerProperties);
export default __webpack_public_path__ + "static/media/fertilizer-properties.a2da286a6780929374ff8a35233a7ca5.svg";
export { ForwardRef as ReactComponent };